import { createSlice } from '@reduxjs/toolkit'
import { GetNews } from '../api/NewsApi'

const initialState = {
    news:[],
    loading:false,
}

export const NewsSlice = createSlice({
  name: 'NewsSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

    
      builder.addCase(GetNews.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(GetNews.fulfilled , (state, action) => {
       
        state.news=action.payload?.data?.data; 
      
        state.loading = false;
      })
      builder.addCase(GetNews.rejected, (state, action) => {
        state.loading = false;
      
      })
    
  },

})



export default NewsSlice.reducer